import 'react-app-polyfill/stable';
import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { registerAllModules } from 'handsontable/registry';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from '@bundles/App';
import ConnectedIntlProvider from '@components/IntlConnect';
import ThemeProvider from '@components/ThemeProvider';
import { sentryConfig } from '@config';
import { isProduction, isTest } from '@helpers/env';
import store from '@store';
import theme from '@theme';

if ((isProduction() || isTest()) && sentryConfig.dsn) {
  Sentry.init(sentryConfig);
}

// register Handsontable's modules
registerAllModules();

const init = (): void => {
  const container = document.getElementById('app');

  if (container) {
    const root = createRoot(container);

    root.render(
      <Provider store={store}>
        <ConnectedIntlProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </StyledEngineProvider>
        </ConnectedIntlProvider>
      </Provider>
    );
  }
};

init();
